export const GROUP_ATTENDANCE = '/api/v1/journals/group-attendance/for-parent';

export const GROUP_MONTHLY_ATTENDANCE = '/api/v1/journals/group-attendance/for-parent/monthly';
